import i18n from "i18next";
import { initReactI18next, useTranslation } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpBackend from "i18next-http-backend";
import { useEffect } from "react";

// Language metadata (label + flag emoji for the switcher)
export const LANGUAGES = [
  { code: "en", label: "English", flag: "GB" },
  { code: "de", label: "Deutsch", flag: "DE" },
  { code: "fr", label: "Français", flag: "FR" },
  { code: "it", label: "Italiano", flag: "IT" },
  { code: "es", label: "Español", flag: "ES" },
  { code: "pt", label: "Português", flag: "PT" },
  { code: "no", label: "Norsk", flag: "NO" },
];

export const SUPPORTED_LANGS = LANGUAGES.map((l) => l.code);

if (!i18n.isInitialized) {
  i18n
    .use(HttpBackend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      backend: {
        // Locale files are served fresh by the backend from <backend>/locales/{lng}.json
        // — edit those and reload the page; no rebuild required.
        loadPath: "/api/locales/{{lng}}",
      },
      load: "languageOnly", // "de-CH" -> load "de"
      fallbackLng: "en",
      supportedLngs: SUPPORTED_LANGS,
      nonExplicitSupportedLngs: true,
      interpolation: { escapeValue: false },
      detection: {
        order: ["localStorage", "navigator", "htmlTag"],
        lookupLocalStorage: "smn_lang",
        caches: ["localStorage"],
      },
      returnEmptyString: false,
      react: {
        useSuspense: true,
      },
    });
}

export function useLang() {
  const { t, i18n: i18nInstance } = useTranslation();
  const lang = i18nInstance.resolvedLanguage || i18nInstance.language || "en";
  const setLang = (l) => {
    i18nInstance.changeLanguage(l);
  };
  return { t, lang, setLang };
}

export function LangProvider({ children }) {
  useEffect(() => {
    const applyLang = (lng) => {
      document.documentElement.lang = lng;
    };
    applyLang(i18n.resolvedLanguage || i18n.language || "en");
    i18n.on("languageChanged", applyLang);
    return () => i18n.off("languageChanged", applyLang);
  }, []);
  return children;
}

export default i18n;
